export default "__VITE_ASSET__BpyugEY1__"